import i18n from '../../i18n';

const BASE_PLAN_IDS = new Set(['essential', 'pro', 'essential-and-voice', 'pro-and-voice']);

const EXTRA_MINUTES_KEYS = {
  extra_minutes_100: 'billing.extra100',
  extra_minutes_500: 'billing.extra500',
  extra_minutes_1000: 'billing.extra1000',
};

const formatFallbackPlanId = (planId) => planId
  .split('-')
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ');

/** Localized display name for a catalog / subscription plan id. */
export function getPlanName(planId) {
  if (!planId) return i18n.t('common.noPlanSelected');
  if (planId === 'trial') return i18n.t('billing.trialName');

  const key = `billing.plans.${planId}.name`;
  return i18n.exists(key) ? i18n.t(key) : formatFallbackPlanId(planId);
}

export function getPlanDescription(planId) {
  const key = `billing.plans.${planId}.description`;
  return i18n.exists(key) ? i18n.t(key) : '';
}

export function getPlanFeatures(planId) {
  if (!BASE_PLAN_IDS.has(planId)) return [];
  return ['f1', 'f2', 'f3', 'f4'].map((suffix) => i18n.t(`billing.plans.${planId}.${suffix}`));
}

export function getExtraMinutesName(productId) {
  const key = EXTRA_MINUTES_KEYS[productId];
  return key ? i18n.t(key) : productId;
}

/** Overlay localized catalog strings onto a product from BILLING_CATALOG. */
export function getLocalizedCatalogProduct(product) {
  if (!product?.id || !BASE_PLAN_IDS.has(product.id)) return product;
  return {
    ...product,
    name: getPlanName(product.id),
    description: getPlanDescription(product.id),
    features: getPlanFeatures(product.id),
  };
}
